import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { authGuard } from './security/auth.guard';
import { CreateRequestComponent } from './components/create-request/create-request.component';
import { ExcelReportsComponent } from './components/excel-reports/excel-reports.component';

export const routes: Routes = [
  {path:"login",component:LoginComponent},
  {path:"dashboard",component:DashboardComponent,canActivate:[authGuard]},
  {path:"newRequest", component: CreateRequestComponent,canActivate:[authGuard]},
  {path:"reports", component: ExcelReportsComponent, canActivate:[authGuard]},
  {path:"",redirectTo:"/login",pathMatch:"full"},
  { path: '**', redirectTo: '/login' }
];
